module.exports = __webpack_public_path__ + "img/logo-new.e1313607.png";